import { type FC } from 'react';

import { mergeSx } from '../../util/mui/sx';
import { Typography, type TypographyProps } from '../typography/Typography';

const ErrorVariant = {
  error: 'fieldErrorText',
  warning: 'fieldWarningText',
} as const;

export interface HelperTextProps extends Omit<TypographyProps<'div'>, 'variant'> {
  readonly error?: boolean | string;
  readonly errorLevel?: 'error' | 'warning';
}

/**
 * A component that renders the helper text for a given input field, allowing an 'error' to be
 * provided as a message that should replace the helper text if present.
 */
export const HelperText: FC<HelperTextProps> = ({ error, errorLevel = 'error', ...props }) => {
  const hasError = (typeof error === 'string' && error.trim().length !== 0) || Boolean(error);
  return (
    <Typography
      component='div'
      {...props}
      sx={mergeSx({ marginLeft: 0.5, marginTop: 0.5 }, props.sx)}
      variant={hasError ? ErrorVariant[errorLevel] : 'fieldHelperText'}
    >
      {typeof error === 'string' && error.trim().length !== 0 ? error : props.children}
    </Typography>
  );
};
